import React, { useState, useEffect } from 'react';
import { getProducts } from '../services/api';
import { Box, Grid, Typography, Container } from '@mui/material';
import ProductCard from '../components/ProductCard';
import ProductList from '../components/ProductList';

function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getProducts();
        setProducts(response.data || []); // Ensure we always have an array
        setLoading(false);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Failed to load products');
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) return <Typography>Loading...</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Container>
      <Box sx={{ flexGrow: 1, mt: 4 }}>
        <Typography variant="h4" gutterBottom>
        </Typography>
        {products.length > 0 ? (
          <ProductList products={products} />
        ) : (
          <Typography>No products available</Typography>
        )}
      </Box>
    </Container>
  );
}

export default Home;